var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMyorderReturnedToRequester(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Myorder_Returned_to_Requester"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Myorder_Returned_to_Requester",
    "data-name": "Myorder_Returned to Requester",
    clipPath: "url(#clip-Myorder_Returned_to_Requester)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9861",
    "data-name": "Group 9861",
    transform: "translate(-1176.75 -232)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9719",
    "data-name": "Group 9719",
    transform: "translate(1176.75 232)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9857",
    "data-name": "Group 9857",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_433",
    "data-name": "Ellipse 433",
    fill: "none",
    stroke: "#58697c",
    strokeWidth: 1.4
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 7,
    r: 7,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 7,
    r: 6.3,
    fill: "none"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9869",
    "data-name": "Group 9869",
    transform: "translate(1180.849 236.604)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19442",
    "data-name": "Path 19442",
    d: "M0,2.243,2.34,0,4.731,2.243",
    transform: "translate(0 4.731) rotate(-90)",
    fill: "none",
    stroke: "#58697c",
    strokeLinecap: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19444",
    "data-name": "Path 19444",
    d: "M5068.193-6882.6h5.277",
    transform: "translate(-5068.087 6885.042)",
    fill: "none",
    stroke: "#58697c",
    strokeLinecap: "round",
    strokeWidth: 1.3
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyorderReturnedToRequester);
export default __webpack_public_path__ + "static/media/Myorder_Returned_to_Requester.fdac23413a66996c7845ce09cb7cf019.svg";
export { ForwardRef as ReactComponent };